import styled, { css } from 'styled-components';

import RichTextComponent from 'components/RichText/RichText';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

const columns = layout.columns.max;

export const ArticleRichTextWrapper = styled.div`
  grid-column: 1/ -1;
  margin-bottom: 64px;

  ${mediaDesktop(css`
    grid-column: 1/ -1;
    margin-bottom: 96px;
  `)}

  word-wrap: normal;

  p,
  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  blockquote {
    grid-column: 2/-2;

    ${mediaDesktop(css`
      grid-column: 5/-5;
    `)}
  }

  p:has(img):last-child {
    ${mediaDesktop(css`
      margin-bottom: 0;
    `)}
  }

  p:has(video):last-child {
    ${mediaDesktop(css`
      margin-bottom: 0;
    `)}
  }

  p:has(img) {
    ${mediaDesktop(css`
      margin-bottom: 64px;
      grid-column: 3/ -3;
    `)}
  }

  p:has(video) {
    ${mediaDesktop(css`
      margin-bottom: 64px;
      grid-column: 3/ -3;
    `)}
  }

  img {
    width: 100%;
  }

  & p + h1,
  p + h2,
  p + h3 {
    padding-bottom: 94px;
  }

  & h1,
  h2,
  h3 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)}

    padding-bottom: 48px;

    ${mediaDesktop(css`
      padding-bottom: 72px;
    `)}
  }

  & p {
    ${({ theme: { locale } }) => setTypography('body', locale)}
    padding-bottom: 1em;

    &:last-child {
      padding-bottom: 0;
    }

    & + ul,
    & + ol {
      margin-top: 14px;
    }
  }

  & p + h4,
  p + h5,
  p + h6 {
    padding-top: calc(64px - 1em);
  }

  & h4,
  h5,
  h6 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)}
    padding-top: 64px;
    padding-bottom: 24px;

    &:first-child {
      padding-top: 0;
    }
  }

  blockquote + blockquote {
    margin-top: 0;
  }

  & ul {
    list-style-type: disc;
    font-weight: 300;
    margin: 32px 0 32px 16px;

    li {
      font-weight: 110;
    }
  }

  & ol {
    list-style-type: decimal;
    margin: 32px 0 32px 18px;
  }

  & li {
    padding: 12px 0 0 16px;

    &:first-child {
      padding-top: 0;
    }
  }

  & blockquote {
    padding-left: 32px;
    margin-top: calc(40px - 1em);
    margin-bottom: 40px;
    border-left: 3px solid ${({ theme }) => theme.colors.black};

    ${mediaDesktop(css`
      width: calc(100% + 40px);
      margin-top: calc(56px - 1em);
      margin-bottom: 56px;
      padding-left: 40px;
    `)}

    p {
      &:first-child {
        margin-top: 0;
        margin-bottom: 32px;
        padding-bottom: 0;
      }

      &:nth-child(2) {
        ${({ theme: { locale } }) => setTypography('smallBody', locale)}
      }
    }
  }

  & > video {
    width: 100%;
  }

  blockquote + p:has(img) {
    margin-top: 8px;
    margin-bottom: 64px;

    ${mediaDesktop(css`
      margin-bottom: 96px;
    `)}
  }

  & strong {
    font-weight: 135;
  }
`;

export const RichText = styled(RichTextComponent)`
  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${columns}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  color: ${colors.lighterMineShaft};

  ${mediaDesktop(`
    grid-template-columns: [out-left] 124px repeat(${columns}, [content] minmax(0px, 1fr)) [out-right] 124px;
  `)}
`;
